import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PopupPasswordTemplateComponent } from "@shared/components/popup-password-template/popup-password-template.component";
import { PASSWORD_REQUIREMENTS } from "@shared/constants/validators.constants";
import { PasswordErrorComponent } from "@shared/layout/password-error/password-error.component";
import { ButtonModule } from "primeng/button";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PasswordModule } from "primeng/password";
import { TooltipModule } from "primeng/tooltip";
@Component({
  selector: "app-password-form",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    OverlayPanelModule,
    ButtonModule,
    PasswordErrorComponent,
    TranslateModule,
    PasswordModule,
    TooltipModule,
    PopupPasswordTemplateComponent,
  ],
  templateUrl: "./password-form.component.html",
  styleUrls: ["./password-form.component.scss"],
})
export class PasswordFormComponent {
  @Input() isInitPassword!: boolean;
  @Output() passwordSubmit = new EventEmitter<string>();

  formGroup: FormGroup = new FormGroup(
    {
      newPassword: new FormControl<string | null>(null, {
        validators: [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_REQUIREMENTS)],
        nonNullable: true,
      }),
      confirmPassword: new FormControl<string | null>(null, {
        validators: [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_REQUIREMENTS)],
        nonNullable: true,
      }),
    },
    {
      validators: this.passwordMatchValidator,
    }
  );

  onSubmit() {
    if (this.formGroup.valid) {
      this.passwordSubmit.emit(this.formGroup.value.newPassword!);
    }
  }

  passwordMatchValidator(control: AbstractControl): Record<string, boolean> | null {
    const newPassword = control.get("newPassword")?.value;
    const confirmPassword = control.get("confirmPassword")?.value;

    if (!newPassword || !confirmPassword) {
      return null;
    }

    const passwordsMatch = newPassword === confirmPassword;

    if (!passwordsMatch) {
      control.get("confirmPassword")?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      const confirmControl = control.get("confirmPassword");
      if (confirmControl?.hasError("passwordMismatch")) {
        const errors = { ...confirmControl.errors };
        delete errors["passwordMismatch"];
        confirmControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      return null;
    }
  }
}
